import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setPaymentData } from "../redux/paymentSlice";
import { usePayment } from "../hooks/usePayment";
import CartItems from "../components/CartItems";
import OrderSummary from "../components/OrderSummary";
import DeliveryAddress from "../components/DeliveryAddress";
import PaymentMethods from "../components/PaymentMethods";
import PaymentButton from "../components/PaymentButton";
import PaymentFooterInfo from "../components/PaymentFooterInfo";
import Footer from "../../../../components/Footer/Footer";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import "../styles/PaymentPage.css";
import CartHeader from "../../../../components/Navbars/CartHeader";
import CartFooter from "../../../../components/Footer/CartFooter";

const PaymentPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orderResponse, checkoutData, orderPayload } =
    location.state || {};
  if (orderResponse === undefined) {
    navigate("/cart");
  }
  useEffect(() => {
    document.title = "Obsessions - Payment Page";
    dispatch(
      setPaymentData({ orderResponse, checkoutData, orderPayload })
    );
  }, []);

  const {
    selectedPayment,
    setSelectedPayment,
    isProcessing,
    startPayment,
  } = usePayment(orderResponse);

  const breadcrumbPaths = [
    { label: "Cart", to: "/cart" },
    { label: "Checkout", to: "/checkout/init" },
    { label: "Payment", to: "" },
  ];
  return (
    <>
      <CartHeader/>
      <Toaster position="top-right" />
      {/* <Breadcrumbs paths={breadcrumbPaths} /> */}
      {/* <div className="root-title-chk">
             <h2 className="title_chk">Payment</h2>
      </div> */}

      {/* <div className="cart_mlb">
        <span className="txt_mlb_my"> Payment</span>
      </div> */}

      <div className="checkout-container_chk checkout-containerbox" style={{ backgroundColor:"#fafafa", marginTop:"-20px", paddingTop:"28px"}}>
        {/* RIGHT SIDE */}
        {/* <CartItems checkoutData={checkoutData} /> */}

        <div className="checkout-right_ck">
           <DeliveryAddress 
           orderPayload={orderPayload} 
           orderResponse={orderResponse} 
           />
        </div>

        {/* LEFT SIDE */}
        <div className="checkout-left_ck">
          <div className="checkbox-section" style={{ background:"#FFF"}}>
          <OrderSummary checkoutData={checkoutData} />
           <PaymentMethods
            gateways={orderResponse?.data?.payment_gateways}
            selectedPayment={selectedPayment}
            setSelectedPayment={setSelectedPayment}
          />
          <PaymentButton
            isProcessing={isProcessing}
            startPayment={startPayment}
          />
          <PaymentFooterInfo />

           </div>
        </div>
      </div>
       
       <CartFooter/>
      {/* <Footer /> */}
    </>
  );
};

export default PaymentPage;
